import * as React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

function EmailListSkeleton() {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Skeleton variant="rectangular" width="100%" height={32} />
            <Skeleton variant="rectangular" width="100%" height={36} />
            <Skeleton variant="rectangular" width="100%" height={36} />
            <Skeleton variant="rectangular" width="100%" height={36} />
            <Skeleton variant="rectangular" width="100%" height={36} />
        </Box>
    );
}

export default EmailListSkeleton;
